import React, { useState, useEffect, useRef } from 'react';

function useProgressBar(done, finishCallBack) {
  const [progress, setProgress] = useState(0);
  const initialSpeed = 0.25; // Initial speed multiplier (adjust to make slower)

  const animationFrameId = useRef(null); // ref to store the animation frame id

  const updateProgress = () => {
    setProgress((prevProgress) => {
      if (prevProgress >= 100) {
        cancelAnimationFrame(animationFrameId.current);
        return 100;
      }

      const newProgress = prevProgress + initialSpeed * Math.max(0.1, (100 - prevProgress) * 0.005);
      return Math.min(newProgress, 100);
    });

    animationFrameId.current = requestAnimationFrame(updateProgress);
  };

  useEffect(() => {
    animationFrameId.current = requestAnimationFrame(updateProgress);

    return () => cancelAnimationFrame(animationFrameId.current);
  }, []);

  useEffect(() => {
    if (done) {
      cancelAnimationFrame(animationFrameId.current);
      setProgress(100);
    }
  }, [done]);

  return progress
}

export function ProgressBar({ done }) {
  const progress = useProgressBar(done)

  return (
    <div style={{ width: '100%', backgroundColor: '#ddd', borderRadius: '10px', height: '10px' }}>
      <div
        style={{
          width: `${progress}%`,
          backgroundColor: '#fd7e14',
          borderRadius: '10px',
          height: '100%',
          transition: 'width 0.05s ease-out'
        }}
      />
    </div>
  )
}